import React from "react";
import "./Sections.css";
import "./Utils.css";
import {Grid} from "@material-ui/core";
import Gimage from "./Gimage";
import {SectionProps} from "./Section";
import BoxEffect from "./BoxEffect";


const WhoAmISection:React.FC<SectionProps> = (props) => {
    return(
        <div className={"SectionBase WhoAmI"}>
            <div className={"SectionContent WhoAmI"}>
                <BoxEffect isActive={props.isActive} delay={0.0}>
                    <div className={"SectionTitle"}>
                        Who Am I ?
                    </div>
                </BoxEffect>
                <BoxEffect isActive={props.isActive} delay={0.125}>
                    <div className={"SectionSubtitle"}>
                        自己紹介
                    </div>
                </BoxEffect>
                <div>
                    <Grid container>
                        <Grid item xs={12} sm={4}>
                            <div className={"Padding5vw"}>
                                <div style={{border:"dashed 1px #1a1a1a"}}>
                                    <Gimage src={"twitter_icon.jpg"}/>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={8} style={{backgroundColor:"rgba(255,255,255,0.75)",border:"solid 1px #1a1a1a",padding:"10px"}}>
                            <BoxEffect isActive={props.isActive} delay={0.25}>
                                <div className={"SectionTitle"}>
                                    避雷/平井龍之介
                                </div>
                            </BoxEffect>
                            <div className={"Padding10"}>
                                <BoxEffect isActive={props.isActive} delay={0.375}>
                                    <div className={"SectionSubtitle"}>
                                        所属/Belong To
                                    </div>
                                </BoxEffect>
                                <div className={"Padding10"}>
                                    -東京大学 計数工学科/University of Tokyo,Department of Mathematical Engineering and Information Physics
                                </div>
                                <BoxEffect isActive={props.isActive} delay={0.5}>
                                    <div className={"SectionSubtitle"}>
                                        興味/Interested In
                                    </div>
                                </BoxEffect>
                                <div className={"Padding10"}>
                                    -CGエンジニアリング<br/>
                                    -デザイン<br/>
                                    -インタラクティブ・ジェネラティブなプログラム<br/>
                                    -言語処理系<br/>
                                    -GAN<br/>
                                    -創作するアルゴリズム<br/>
                                </div>
                                <BoxEffect isActive={props.isActive} delay={0.625}>
                                    <div className={"SectionSubtitle"}>
                                        スキル/Skills
                                    </div>
                                </BoxEffect>
                                <div className={"Padding10"}>
                                    -Unity<br/>
                                    -C#<br/>
                                    -GLSL/ShaderLab<br/>
                                    -JavaScript/Typescript<br/>
                                </div>
                                <BoxEffect isActive={props.isActive} delay={0.75}>
                                    <div className={"SectionSubtitle"}>
                                        実績・経歴/Achievements
                                    </div>
                                </BoxEffect>
                                <div className={"Padding10"}>
                                    -Unityインターハイ2016 準優勝 <br/>
                                    -VRコンソーシアムアワード2019一次選考通過 <br/>
                                    -いばらきデジタルコンテンツ・ソフトウェア大賞2019一次選考通過 <br/>
                                    -IPA未踏2020採択・スーパークリエイター「シェーダー・ライブコーディング・アーカイブシステムの作成」 <br/>
                                    -2019/4~2020/1 cluster<br/>
                                </div>

                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )
}

export default WhoAmISection;